import { ControllerFieldState, ControllerRenderProps } from 'react-hook-form'

interface PropsField {
  field: ControllerRenderProps<any>
  fieldState: ControllerFieldState
  setCategory: () => void
  fieldBrand: () => void
  labelColor?: string
  ele?: any
}

export const setFilterSide = (extra: any) => {
  const { control, productAttr, setCategory, setBrand } = extra

  //console.log('disableSelect', disableSelect)

  const fieldsSizes = [
    {
      classNameContainer: 'mt-2 mb-2 w-60 mr-8 sm:mr-2',
      typeComp: 'react-select',
      controllerProps: {
        name: 'productSizeId',
        defaultValue: { label: 'Todos', value: '' },
        control,
      },
      compProps: ({ field, labelColor }: PropsField) => {
        return {
          labelColor: labelColor ? labelColor : 'text-balck',
          title: 'Rodado',
          name: 'rodado',
          value: field.value,
          defaultValue: { label: 'Todos', value: '' },
          options: productAttr?.productSize,
          onChange: (e: any) => {
            field.onChange(e)
          },
        }
      },
    },
    {
      classNameContainer: 'mt-2 mb-2 w-60 mr-8 sm:mr-2',
      typeComp: 'react-select',
      controllerProps: {
        name: 'productWidthId',
        defaultValue: { label: 'Todos', value: '' },
        control,
      },
      compProps: ({ field, labelColor }: PropsField) => {
        return {
          labelColor: labelColor ? labelColor : 'text-balck',
          title: 'Ancho',
          name: 'ancho',
          value: field.value,
          defaultValue: { label: 'Todos', value: '' },
          options: productAttr?.productWidth,
          onChange: (e: any) => {
            field.onChange(e)
          },
        }
      },
    },
    {
      classNameContainer: 'mt-2 mb-2 w-60 mr-8 sm:mr-2',
      typeComp: 'react-select',
      controllerProps: {
        name: 'productHeightId',
        defaultValue: { label: 'Todos', value: '' },
        control,
      },
      compProps: ({ field, labelColor }: PropsField) => {
        return {
          labelColor: labelColor ? labelColor : 'text-balck',
          title: 'Alto',
          name: 'alto',
          value: field.value,
          defaultValue: { label: 'Todos', value: '' },
          options: productAttr?.productHeight,
          onChange: (e: any) => {
            field.onChange(e)
          },
        }
      },
    },
  ]

  const fieldCategory = [
    {
      classNameContainer:
        'flex justify-between items-center mb-2 w-[208px] sm:ml-4',
      typeComp: 'input',
      controllerProps: {
        name: 'categoryId',
        control: control,
      },
      compProps: ({ field, ele }: PropsField) => {
        return {
          label: ele.name,
          type: 'radio',
          value: ele.id,
          checked: field.value == ele.id,
          className: 'w-4 h-4 p-2 border rounded-full bg-gray-200',
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            // console.log('e.target.value', e.target.value, ele.id)
            field.onChange(e.target.value)
            setCategory(e, ele)
          },
        }
      },
    },
  ]

  const fieldBrand = [
    {
      classNameContainer:
        'flex justify-between items-center mb-2 w-[208px] sm:ml-4',
      typeComp: 'input',
      controllerProps: {
        name: 'brandId',
        control: control,
      },
      compProps: ({ field, ele }: PropsField) => {
        return {
          label: ele.name,
          type: 'radio',
          value: ele.id,
          checked: field.value == ele.id,
          className: 'w-4 h-4 p-2 border rounded-full bg-gray-200',
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            // console.log('e.target.value', e.target.value, ele.id)
            field.onChange(e.target.value)
            setBrand(e, ele)
          },
        }
      },
    },
  ]

  return { fieldsSizes, fieldCategory, fieldBrand }
}
